import { render, staticRenderFns } from "./xiaoqu.vue?vue&type=template&id=f0d017c2"
import script from "./xiaoqu.vue?vue&type=script&lang=js"
export * from "./xiaoqu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports